<template>
    <div>
        <canvas ref="gradientCanvas" style="display: none"></canvas>
        <component
            :is="chartType"
            :data="chartData"
            :dataset="chartDataset"
            :height="parentHeight"
            refresh="10"
            v-bind="$attrs"
            :key="refreshKey"
        />
    </div>
</template>

<script>
console.log('GradientChart.vue')
import {defineComponent} from 'vue'
import { ColumnChart, LineChart, AreaChart } from 'vue-chartkick'

export default defineComponent({
    name: 'GradientChart',
    components: { ColumnChart, LineChart, AreaChart },
    inheritAttrs: false,
    props: {
        type: {
            type: String,
            default: 'column',
            // validator: value => ['column', 'line', 'area'].includes(value)
        },
        colors: {
            type: Array,
            default: () => []
        },
        data: {
            type: [Array, Object],
            required: true
        },
        options: {
            type: Object,
            default: () => ({})
        },
        dataUrl: {
            type: String,
            default: ''
        },
        refresh: {
            type: Number,
            default: 10  // refresh interval in seconds
        }
    },
    computed: {
        chartType() {
            const types = {
                column: 'column-chart',
                line: 'line-chart',
                area: 'area-chart'
            }
            return types[this.type]
        },
        chartDataset() {
            return {
                borderWidth: 0,
                backgroundColor: this.gradient,
                borderRadius: 10,
                ...this.options.dataset
            }
        }
    },
    data() {
        return {
            gradient: null,
            chartData: this.data,
            refreshKey: 0
        }
    },
    mounted() {
        this.createGradient();
        if (this.dataUrl) {
            this.fetchChartData();
            this.pollTimer = setInterval(this.fetchChartData, this.refresh * 1000);
        }
    },
    unmounted() {
        if (this.pollTimer) {
           clearInterval(this.pollTimer);
        }
    },
    methods: {
        fetchChartData() {
            if (!this.dataUrl) return;
            axios.get(this.dataUrl)
                 .then(response => {
                     this.chartData = response.data;
                     this.refreshKey++;
                 })
                 .catch(error => {
                     console.error("Error fetching chart data:", error);
                 });
        },
        createGradient() {
            if (this.colors.length > 0) {
                const ctx = this.$refs.gradientCanvas.getContext('2d')
                const gradient = ctx.createLinearGradient(0, 250, 0, 0)

                this.colors.forEach((color, index) => {
                    gradient.addColorStop(index / (this.colors.length - 1), color)
                })

                this.gradient = gradient
            }
        }
    },
    watch: {
        colors: {
            handler() {
                this.createGradient()
            },
            deep: true
        }
    }
})
</script>
